import { getTimezone } from '@fourthwall/utils/dist/timezone';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { useDashboardFeatureFlags } from '../../../components/utils/DashboardFeatureFlags';
const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const useGetShopTimezone = () => {
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { currentShop } = useCurrentShop();
    const timezoneName = dashboardFeatureFlags.timezone.enabled
        ? currentShop?.timezoneId || browserTimezone
        : browserTimezone;
    return getTimezone(timezoneName);
};
